import axios from 'axios'
import router from '../../router/index'
import UserService from '../../services/userService'
import { Map } from 'core-js'
import * as helpers from '../../helpers/helpers'

// state
const state = {
  selectedUser: null,
  claimsForSelectedUser: null,
  leftProjectsForSelectedUser: null
}

// getters
const getters = {
  selectedUser: state => state.selectedUser,
  claimsForSelectedUser: state => state.claimsForSelectedUser,
  leftProjectsForSelectedUser: state => state.leftProjectsForSelectedUser
}

// actions
const actions = {
  editClaimForSelectedUser({ commit }, payload) {
    const item = payload.item
    commit('updateClaimsForSelectedUser', { targetLevel: payload.targetLevel, item: item })
  }
}

// mutations
const mutations = {
  setSelectedUser(state, value) {
    state.selectedUser = value
    state.claimsForSelectedUser = value == null ? [] : state.selectedUser.myClaims
    state.leftProjectsForSelectedUser = value == null ? [] : state.selectedUser.leftProjectList
  },
  updateClaimsForSelectedUser(state, { targetLevel, item }) {
    const index = state.selectedUser.myClaims.findIndex(obj => obj.identifier == item.identifier)
    const jIndex = state.selectedUser.leftProjectList.findIndex(obj => obj.projectId == item.projectId)
    if (index != -1 && targetLevel != 'noAccess') {
      state.selectedUser.myClaims[index].level = targetLevel
    } else if (index != -1 && targetLevel == 'noAccess') {
      state.selectedUser.myClaims.splice(index, 1)
      delete item['scope']
      delete item['identifier']
      delete item['level']
      state.selectedUser.leftProjectList.push(item)
    } else if (index == -1) {
      const data = { scope: 'Project', identifier: item.projectId, level: targetLevel }
      item = { ...item, ...data }
      state.selectedUser.myClaims.push(item)
      state.selectedUser.leftProjectList.splice(jIndex, 1)
    }
    state.claimsForSelectedUser = state.selectedUser.myClaims
    state.leftProjectsForSelectedUser = state.selectedUser.leftProjectList
  },
  updateStatusForSelectedUser(state, newValue) {
    state.selectedUser.isEnabled = newValue
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/usermanagement.js